import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { IDocument } from '../modelviewer/types';
import { baseQuery } from './baseQuery';

export const masterDocumentApi = createApi({
  baseQuery: baseQuery,
  reducerPath: 'masterDocumentApi',
  endpoints: builder => ({
    getAllMasterDocument: builder.query<any, string>({
      query: selection => ({
        url: endPoints.masterDocument.getAll.url + selection
      }),
      keepUnusedDataFor: endPoints.masterDocument.getAll.keepUnusedDataFor
    })
  })
});

export const { useGetAllMasterDocumentQuery } = masterDocumentApi;
